import { MAX_FILESIZE } from "@nnr/global";
import { GetGroupUsersDto, GetUsersDto } from "./gen-api";

export type UserRole = GetUsersDto["data"][number]["role"];
export type SystemRole = GetUsersDto["data"][number]["role"];
export type GroupRole = GetGroupUsersDto["data"][number]["groupRole"];

export const LIBRARY_FILE_ALLOWED_TEXT = `PDF, images, docx, pptx, and text files - max ${MAX_FILESIZE / (1024 * 1024)} MB`;
